import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import Button from '../../../components/UI/Button/Button'
import DatePicker from '../../../components/UI/DatePicker/DatePicker'
import Search from '../../../components/UI/Search/Search'
import Select from '../../../components/UI/Select/Select'
import Table from "../../../components/UI/Table/Table"
import FetchData from '../../../shared/fetchData'
import './OrderReports.css'

const OrderReports = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [kiosks, setKiosks] = React.useState([])
    const [kiosk, setKiosk] = React.useState('')
    const [units, setUnits] = React.useState([])
    const [unit, setUnit] = React.useState('')
    const [lockerTypes, setLockerTypes] = React.useState([])
    const [lockerType, setLockerType] = React.useState('')
    const [creditChangeType, setCreditChangeType] = React.useState([])
    const [creditChangeTypes, setCreditChangeTypes] = React.useState([])
    const [credits, setCredits] = React.useState([])

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        var raw = JSON.stringify({
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/creditchanges/getCreditChangeTypes'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setCreditChangeTypes(result.creditChangeTypes)
                }
            })
            .catch(error => setLoading(false))
        var url = 'management/api/v1/kiosks/getKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setKiosks(result.kiosks)
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "unit": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setUnits(result.units)
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "lockerType": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/lockertypes/getLockerTypes'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setLockerTypes(result.lockerTypes)
                }
            })
            .catch(error => console.log(error))
    }, [])
    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }
    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const afterCloseModal = (event) => {
    }
    const exportToCSV = (event) => {
        var raw = JSON.stringify({

            "from": from != null && from != '' ? from : null,
            "to": to != null && to != '' ? to : null,
            "kioskId": kiosk != null && kiosk != '' ? kiosk.value : null,
            "lockerTypeId": lockerType != null && lockerType != '' ? lockerType.value : null,
            "accountId": unit != null && unit != '' ? unit.value : null,
            "changeTypes": creditChangeType,
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/creditchanges/getCreditReport'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.creditChanges.map(o => {
                        count++
                        exportOrderReport.push({
                            'ردیف': count,
                            'شماره سفارش': o.orderNumber,
                            'تاریخ ثبت': o.registerDate,
                            'تاریخ ثبت': o.unitName,
                            "تاریخ شروع": o.startDate,
                            "ساعت شروع": o.startTime,
                            "تاریخ پایان": o.endDate,
                            "ساعت پایان": o.endTime,
                            "هزینه باکس": o.lockerAmount,
                            "مالیات بر ارزش افزوده": o.taxAmount,
                            "عوارض": parseInt(o.taxAmount) / 3,
                            "مالیات": parseInt(o.taxAmount) * 2 / 3,
                            "هزینه نهایی": o.finalAmount,
                            'دلیل کنسلی': o.cancelReason,
                            "لاکر": o.kioskName,
                            "سریال باکس": o.lockerSerial,
                            "واحد": o.unitName
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'OrderReports' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const changeKiosk = selectedOption => {
        setKiosk(selectedOption)
    }

    const changeUnit = selectedOption => {
        setUnit(selectedOption)
    }

    const changeLockerType = selectedOption => {
        setLockerType(selectedOption)
    }

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "from": from != null && from != '' ? from : null,
            "to": to != null && to != '' ? to : null,
            "kioskId": kiosk != null && kiosk != '' ? kiosk.value : null,
            "lockerTypeId": lockerType != null && lockerType != '' ? lockerType.value : null,
            "accountId": unit != null && unit != '' ? unit.value : null,
            "changeTypes": creditChangeType,
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/creditchanges/getCreditReport'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.creditChanges)
                    pushData(newList)
                    setCredits(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'description',
                header: "شرح",
                align: 'center',
            },
            {
                accessorKey: 'orderNumber',
                header: 'شماره سفارش',
                align: 'center',
            },
            {
                accessorKey: 'registerDate',
                header: 'تاریخ ثبت',
                align: 'center',
            },
            {
                accessorKey: 'unitName',
                header: 'نام حساب',
                align: 'center',
            },
            {
                accessorKey: 'startDate',
                header: "تاریخ شروع",
                align: 'center',
            },
            {
                accessorKey: 'startTime',
                header: "ساعت شروع",
                align: 'center',
            },
            {
                accessorKey: 'endDate',
                header: "تاریخ پایان",
                align: 'center',
            },
            {
                accessorKey: 'endTime',
                header: "ساعت پایان",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                description: d.description,
                orderNumber: d.orderNumber,
                registerDate: d.registerDate,
                unitName: d.unitName,
                startDate: d.startDate,
                startTime: d.startTime,
                endDate: d.endDate,
                endTime: d.endTime,
                isActive: d.isActive != null && d.isActive == '1' ? 'فعال است' : 'فعال نیست',
                subRows: [
                    { header: 'هزینه باکس', value: d.lockerAmount ? d.lockerAmount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                    // { header: 'مالیات', value: d.endTime },
                    { header: 'عوارض', value: !!d.taxAmount ? (parseInt(d.taxAmount) / 3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                    { header: 'مالیات', value: !!d.taxAmount ? (parseInt(d.taxAmount) * 2 / 3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                    { header: 'هزینه نهایی', value: !!d.finalAmount ? d.finalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '' },
                    { header: 'دلیل کنسلی', value: d.cancelReason },
                    { header: 'لاکر', value: d.kioskName },
                    { header: 'سریال باکس', value: d.lockerSerial },
                    { header: 'واحد', value: d.unitName },
                ],
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refreshFn = (event) => {
        setKiosk('');
        setUnit('');
        setLockerType('');
        setFrom('');
        setTo('');
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }
    const addCreditChangeType = (event, value) => {
        if (creditChangeType != null && creditChangeType.length != 0 && creditChangeType.includes(value)) {
            let cct = creditChangeType.filter(c => c !== value)
            setCreditChangeType([...cct])
        } else {
            let cct = creditChangeType
            cct.push(value)
            setCreditChangeType([...cct])
        }
    }
    const kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    const unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }
    const lockerTypeList = []
    if (lockerTypes != null && lockerTypes.length != 0) {
        lockerTypes.map(z => {
            lockerTypeList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    let creditTypeList = creditChangeTypes.map(p => {
        return (
            <div className="col-4 full-small">
                <label className="container pb-2 role-text">{p.description}
                    <input type="checkbox"
                        checked={creditChangeType != null && creditChangeType.length != 0 && creditChangeType.includes(p.id)}
                        onChange={(event) => addCreditChangeType(event, p.id)}
                        value={p.id} id="flexCheckDefault" />
                    <span className="checkmark"></span>
                </label>
            </div>
        )
    })
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refreshFn}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-4 small-ord-col">
                <DatePicker change={changeFromDate} value={from} placeHolder="از تاریخ" />
            </div>
            <div className="col-4 small-ord-col">
                <DatePicker change={changeToDate} value={to} placeHolder="تا تاریخ" />
            </div>
            <Select
                name="form-field-name"
                value={kiosk}
                placeholder="لاکر"
                options={kioskList}
                onChange={changeKiosk}
                col="4"
            />
            <Select
                name="form-field-name"
                value={unit}
                placeholder="حساب"
                options={unitList}
                onChange={changeUnit}
                col="4"
            />
            <Select
                name="form-field-name"
                value={lockerType}
                placeholder="نوع باکس"
                options={lockerTypeList}
                onChange={changeLockerType}
                col="4"
            />
        </div>
        <div className="row mt-4">
            {creditTypeList}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-orderReports">
            <Search class="orders-search" form={form} />
            <div className="row justify-content-center">
                {rerender ?
                    // <Spinner />
                    <Table pageSize={pageSize} data={credits} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                    :
                    <Table pageSize={pageSize} data={credits} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                }
            </div>
        </div>
    )
}
export default OrderReports